import { PermissionSettingPage } from './PermissionSettingPage';
export default PermissionSettingPage;
